<template>
  <div class="matchmaking matchmaking-max-size">
    <h1>TFTHub - Scouting & matchmaking app</h1>
    <div class="grid">
      <div class="cell option">
        <div class="item item-option" @click="reset">Reset all</div>
      </div>
      <div class="cell option">
        <div class="item item-option" @click="buykofi"><a target="_blank" rel="noopener" href="https://ko-fi.com/tfthub"><img src="@/assets/kofi-small.png"/>Buy me a ko-fi!</a></div>
      </div>
    </div>
    <div class="grid matchmaking-max-size">
      <div class="cell">
        <div id="player8" class="item"><input class="input safari-zoom-fix" type="text" v-model="playerNames[7]" @click="matched($event, 8)" @contextmenu.prevent="eliminated($event, 8)"></div>
      </div>
      <div class="cell">
        <div id="player1" class="item"><input class="input safari-zoom-fix" type="text" v-model="playerNames[0]" @click="matched($event, 1)" @contextmenu.prevent="eliminated($event, 1)"></div>
      </div>
      <div class="cell">
        <div id="player2" class="item"><input class="input safari-zoom-fix" type="text" v-model="playerNames[1]" @click="matched($event, 2)" @contextmenu.prevent="eliminated($event, 2)"></div>
      </div>
      <div class="cell">
        <div id="player7" class="item"><input class="input safari-zoom-fix" type="text" v-model="playerNames[6]" @click="matched($event, 7)" @contextmenu.prevent="eliminated($event, 7)"></div>
      </div>
      <div class="cell">
        <div class="item matchmaking-eliminated"></div>
      </div>
      <div class="cell">
        <div id="player3" class="item"><input class="input safari-zoom-fix" type="text" v-model="playerNames[2]" @click="matched($event, 3)" @contextmenu.prevent="eliminated($event, 3)"></div>
      </div>
      <div class="cell">
        <div id="player6" class="item"><input class="input safari-zoom-fix" type="text" v-model="playerNames[5]" @click="matched($event, 6)" @contextmenu.prevent="eliminated($event, 6)"></div>
      </div>
      <div class="cell">
        <div id="player5" class="item"><input class="input safari-zoom-fix" type="text" v-model="playerNames[4]" @click="matched($event, 5)" @contextmenu.prevent="eliminated($event, 5)"></div>
      </div>
      <div class="cell">
        <div id="player4" class="item"><input class="input safari-zoom-fix" type="text" v-model="playerNames[3]" @click="matched($event, 4)" @contextmenu.prevent="eliminated($event, 4)"></div>
      </div>
    </div>
    <div class="grid">
      <div class="cell option">
        <div class="item item-option" @click="renaming($event)">Click to match</div>
      </div>
      <div class="cell option">
        <div class="item item-option" @click="undo">Undo matched</div>
      </div>
      <div class="cell option">
        <div class="item item-option" @click="eliminating($event)">Click to eliminate</div>
      </div>
      <div class="cell option">
        <div class="item item-option" @click="loadOriginalMatchHistory">Load original match history</div>
      </div>
    </div>
    <h2>Matchmaking history</h2>
    <div class="grid">
      <div v-for="(player, index) in matchmakingHistory" v-bind:key="index" class="matchmaking-match">
        {{player + ": " + playerNames[player-1]}}
      </div>
    </div>
    <h2>Matchmaking history after last elimination</h2>
    <div class="grid">
      <div v-for="(player, index) in matchmakingHistoryAfterElimination" v-bind:key="index" class="matchmaking-match">
        {{player + ": " + playerNames[player-1]}}
      </div>
    </div>
    <h3>What is TFTHub app?</h3>
    <p>
      TFTHub app is a fancy notepad for TeamFight Tactics players. It helps you track enemies that you fight, which allows you to predict your next enemies. Below you will find all the necessary information how to use the app, scout, enter names, as well as explained matchmaking algorithm and a bunch of news. If something breaks or you have questions, feel free to contact me! You are free to use this website/app however you want.
    </p>
    <h3><router-link to="/how-to-use">How to use app</router-link></h3>
    <h3><router-link to="/how-to-scout">How to scout/track</router-link></h3>
    <h3><router-link to="/how-to-enter-names">How to enter player names</router-link></h3>
    <h3><router-link to="/matchmaking-algorithm">Matchmaking algorithm</router-link></h3>
    <h3><router-link to="/news">News and changes</router-link></h3>
    <h3><router-link to="/contact">Contact</router-link></h3>
  </div>
</template>

<script>
  const players = Array.apply(null, Array(8));
  let isRenaming = true;
  let isEliminating = false;
  let actionButton = "Click to rename";
  let eliminatingButton = "Click to stop eliminating";

  export default {
    name: 'Matchmaking',
    props: {
      msg: String
    },
    data() {
      return {
        matchmakingHistory: [],
        matchmakingHistoryAfterElimination: [],
        playerNames: []
      }
    },
    created: function () {
      this.initializePlayerStatuses()
      this.initializePlayerNames()
    },
    methods: {
      initializePlayerStatuses: function () {
        players.forEach(function (el, index) {
          players[index] = false
        });
      },
      initializePlayerNames: function () {
        this.playerNames = Array(8).fill("")
      },
      unselect: function(event) {
        var currentElement = event.target
        currentElement.selectionStart = currentElement.selectionEnd
      },
      reset: function () {
        this.matchmakingHistory = []
        this.matchmakingHistoryAfterElimination = []
        this.initializePlayerStatuses()
        this.initializePlayerNames()
        for (const indx in players) {
          this.removeEliminatedClass(parseInt(indx)+1);
        }
        this.renderMatchmaking()
        this.$gtag.event("reset_button")
      },
      renaming: function (event) {
        isRenaming = !isRenaming;
        [event.target.innerHTML, actionButton] = [actionButton, event.target.innerHTML]
        const playerNames = document.getElementsByClassName("input");
        playerNames.forEach(function(item) {
          item.readOnly = !isRenaming
        });
      },
      matched: function (event, indx) {
        if (isRenaming) return
        if (isEliminating) {
          this.eliminated(event, indx)
          return
        }
        if (players[indx-1]) return
        this.matchmakingHistory.push(indx)
        this.matchmakingHistoryAfterElimination.push(indx)
        this.renderMatchmaking();
      },
      undo: function () {
        if (isRenaming) return
        this.matchmakingHistory.pop()
        this.matchmakingHistoryAfterElimination.pop()
        this.renderMatchmaking()
        this.$gtag.event("undo_button")
      },
      removeEliminatedClass: function (indx) {
        const playerItem = document.getElementById("player" + indx).getElementsByTagName("input")[0]
        if (players[indx-1]) playerItem.classList.add("matchmaking-eliminated")
        else playerItem.classList.remove("matchmaking-eliminated")
      },
      eliminated: function (event, indx) {
        players[indx-1] = !players[indx-1]
        this.matchmakingHistoryAfterElimination = []
        this.unselect(event)
        this.removeEliminatedClass(indx)
        this.renderMatchmaking()
      },
      calculateSafeEnemies: function () {
        let activePlayers = players.filter(function (e) {
          return e === false;
        });
        const howManyActive = activePlayers.length;
        let howManyIgnore;
        if (howManyActive > 4) howManyIgnore = howManyActive - 3;
        else if (howManyActive > 2) howManyIgnore = 1;
        else return [];

        let activePlayersHistory = this.matchmakingHistoryAfterElimination;

        if (activePlayersHistory.length < howManyIgnore) howManyIgnore = activePlayersHistory.length;
        return activePlayersHistory.slice(-howManyIgnore);
      },
      calculateUnsafeEnemies: function() {
        let unsafeEnemies = [];
        let safeEnemies = this.calculateSafeEnemies();
        players.forEach(function(item, index) {
          if (!safeEnemies.includes(index+1) && !item) unsafeEnemies.push(index+1)
        });
        return unsafeEnemies;
      },
      renderMatchmaking: function () {
        let safeEnemies = this.calculateSafeEnemies();
        let unsafeEnemies = this.calculateUnsafeEnemies();
        for (const indx in safeEnemies) {
          this.renderSafe(safeEnemies[indx]);
        }
        for (const indx in unsafeEnemies) {
          this.renderUnsafe(unsafeEnemies[indx]);
        }
      },
      renderSafe: function(enemy) {
        document.getElementById("player" + enemy).classList.add("matchmaking-inactive");
      },
      renderUnsafe: function(enemy) {
        document.getElementById("player" + enemy).classList.remove("matchmaking-inactive");
      },
      buykofi: function() {
        this.$gtag.event("buy_kofi")
      },
      loadOriginalMatchHistory: function () {
        this.matchmakingHistoryAfterElimination = [...this.matchmakingHistory];
        this.renderMatchmaking()
      },
      eliminating: function (event) {
        isEliminating = !isEliminating;
        [event.target.innerHTML, eliminatingButton] = [eliminatingButton, event.target.innerHTML]
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .matchmaking {
    margin: 0 auto;
    max-width: 600px;
  }
  .grid {
    display: flex;
    flex-wrap: wrap;
    /*justify-content: space-between;*/ /*not needed?*/
  }
  .matchmaking::after {
     content: "";
     flex: auto;
   }
  .cell {
    flex: 0 0 33.33%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    padding: 0.3rem;
    box-sizing: border-box;
    min-width: 64px;
    min-height: 64px;
  }
  .cell:before {
    content: '';
    margin-top: 100%;
  }
  .item {
    flex-grow: 1;
    border: 1px solid #474747;
    background-color: #400000;

    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .item-option {
    color: #42b983;
    background-color: #2F3335 !important;
    border: #4C565C solid 1px;
  }
  .item-option a {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .item-option a img{
    max-width: 32px;
    max-height: 32px;
    margin: 5px;
  }
  .matchmaking-inactive {
    background-color: #004000 !important;
    cursor:default;
  }
  .matchmaking-eliminated {
    background-color: #2F3335 !important;
  }
  .matchmaking-eliminated:read-only {
    cursor:default;
  }
  .input {
    background:none;
    border:none;
    text-align: center;
    height: 100%;
    width: 100%;
  }
  .safari-zoom-fix {
    font-size: 16px;
  }
  input:read-only {
    cursor: pointer;
  }
  .option {
    flex: 0 0 50%;
    max-height: 100px;
  }
  .matchmaking-match {
    flex: 0 0 calc(20% - 10px);
    background-color: #2F3335 !important;
    border: #4C565C solid 1px;
    margin: 1px;
    padding: 3px;
  }
  p {
    text-align: justify;
  }
/*  @media screen and (orientation:landscape) {
    .matchmaking {
      width: 100vh;
    }
    .matchmaking-grid {
      height: 100vh;
      width: 100vh;
    }
  }
  @media screen and (orientation:portrait) {
    .matchmaking {
      height: 100vh;
    }
    .matchmaking-grid {
      height: 100vw;
      width: 100vw;
    }
  }*/
</style>
